// extracted by mini-css-extract-plugin
export default {"table":"table_table__o62fn","pageButton":"table_pageButton__5F9QS"};